import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { ListarTipoParcelaController } from "../../../Controllers/Cobranca/TipoParcela/TipoParcelaController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ITipoParcela } from "../../../Interfaces/Cobranca/TipoParcela/TipoParcelaInterface";
import ExcluirTipoParcela from "./ExcluirTipoParcela";
import AdicionarTipoParcela from "./ModalAdicionarTipoParcela";
import EditarTipoParcela from "./ModalEditarTipoParcela";

export default function GestaoTipoParcelas() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [page, setPage] = useState(1);

    const {
        value: listarTipoParcelasResponse,
        loading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarTipoParcelaController(page);
    }, [page]);

    const lstTipoParcelas = listarTipoParcelasResponse?.Parcelas;
    const totalPages = listarTipoParcelasResponse?.NR_PAGINAS ?? 1;

    function getColumns(updateList: () => void) {
        const tableViewColumns: Array<ColumnDescription<ITipoParcela>> = [
            {
                dataField: "DS_TIPO",
                text: "Tipo de Parcela",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "DS_DESCRICAO",
                text: "Descrição da Parcela",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "",
                text: "Editar",
                align: "center",
                formatter: (_, row) => (
                    <button
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Editar Tipo Parcela",
                                Component: () => (
                                    <EditarTipoParcela
                                        setShow={setShow}
                                        Parcela={row}
                                        then={updateList}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>
                ),
                isDummyField: true,
                headerAlign: "center",
            },
            {
                dataField: "",
                text: "Excluir",
                align: "center",
                formatter: (_, row) => (
                    <ExcluirTipoParcela
                        ID_TIPO_PARCELA={row.ID_TIPO_PARCELA}
                        then={updateList}
                    />
                ),
                isDummyField: true,
                headerAlign: "center",
            },
        ];

        return {
            tableViewColumns,
        };
    }

    const { tableViewColumns } = useMemo(
        () => getColumns(updateList),
        [updateList]
    );

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <h2 className="mb-0">Tipos de Parcelas</h2>
                <button
                    className="btn btn-sm btn-shadow btn-primary d-flex align-items-center flex-nowrap w-10 mb-4"
                    type="button"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            headerComponent: "Cadastrar Parcela",
                            Component: () => (
                                <AdicionarTipoParcela
                                    setShow={setShow}
                                    then={updateList}
                                />
                            ),
                            size: "lg",
                        });
                    }}
                >
                    Criar Tipo Parcela
                </button>
            </div>
            <div className="card-body">
                <Table
                    data={lstTipoParcelas ?? []}
                    loading={loading}
                    bordered={false}
                    striped={true}
                    columns={tableViewColumns}
                    keyField="ID_TIPO_PARCELA"
                    remote={{ pagination: true }}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    totalPages={totalPages}
                />
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
